import React, {useEffect, useState} from 'react';
import useOpenState from '../../../../hooks/useOpenState';
import MessageBox from '../../../../util/messageBox';
import {useTranslation} from 'react-i18next';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {useAgyleConfigStyles} from '../../agyle_configuration';
import {setSnackbar} from '../../../../store/reducers/globals';
import {useDispatch} from 'react-redux';
import {FormLabel} from '@mui/material';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import _ from 'lodash';
import {DEFAULT_LEVEL_VALUE_CLEANING_REQUEST} from '../configDefaultValues';

const TimeConfigurationCleaningRequest = ({cfg, handleSaveConfig}) => {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [levels, setLevels] = useState(DEFAULT_LEVEL_VALUE_CLEANING_REQUEST);
    const [isModified, setIsModified] = useState(false);

    // Opening states
    const [isWarningOpen, openWarning, closeWarning] = useOpenState(false, true);

    // Load from config
    useEffect(() => {
        if (cfg?.value?.levels) {
            setLevels(cfg?.value?.levels);
        }
    }, [cfg]);

    const onSave = () => {
        handleSaveConfig('levels', levels);
        setIsModified(false);
    };

    const onDefault = () => {
        closeWarning();
        setLevels(DEFAULT_LEVEL_VALUE_CLEANING_REQUEST);
        dispatch(setSnackbar({type: 'info', message: t('Default settings restored.')}));
        setIsModified(true);
    };

    const handleChangeLevel = (event) => {
        const {name, value} = event.target;
        if (!_.isNaN(Number(value))) {
            setLevels(prevState => ({
                ...prevState,
                [`level${name}`]: Number(value),
            }));
            setIsModified(true);
        }
    };

    const renderLevelInfo = (level) => {
        return (
            <div className={classes.smallContext}>
                <FormLabel style={{marginLeft: 5}}>
                    {t('Level')} {level}
                </FormLabel>

                <AgyleTextField
                    placeholder={t('Default time for a specified level')}
                    name={level?.toString()}
                    fullWidth
                    style={{marginTop: 10}}
                    endAdornment={<InputAdornment position="end">{t('minutes')}</InputAdornment>}
                    value={levels?.[`level${level}`]}
                    onChange={handleChangeLevel}
                    type="number"
                />
            </div>
        );
    };

    return (
        <>
            <Typography variant="subtitle2" sx={{marginBottom: '10px'}}>
                {t('Set the default time for Cleaning Request for each levels.')}
            </Typography>

            <div>
                {renderLevelInfo(1)}
                {renderLevelInfo(2)}
                {renderLevelInfo(3)}
            </div>

            <div className={classes.action}>
                <AgyleButton
                    onClick={openWarning}
                    variant="contained"
                >
                    {t('Reset to default')}
                </AgyleButton>

                <AgyleButton
                    onClick={onSave}
                    variant="contained"
                    disabled={!isModified}
                >
                    {t('Save changes')}
                </AgyleButton>
            </div>

            <MessageBox
                open={isWarningOpen}
                onClose={closeWarning}
                title={t('Confirmation')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={onDefault}
                message={t('Are you sure you want to restore the default settings?')}
            />
        </>
    );
};

export default TimeConfigurationCleaningRequest;